// import { useEffect, useState } from "react";
// import { Row, Col, Card, Modal } from "react-bootstrap";
// import balance from "../Assets/images/smartphone.svg";
// import bank from "../Assets/images/bank4.svg";
// import money from "../Assets/images/money.svg";
// import { ReactComponent as Calender } from "../Assets/images/calendar.svg";
// import bankImg from "../Assets/images/bank-img1.png";
// import statement from "../Assets/images/Frame 1.png";
// import earning from "../Assets/images/earning.png";
// import customerservice from "../Assets/images/customer-service.png";
// import phone from "../Assets/images/phone.svg";
// import netbanking from "../Assets/images/netbanking.svg";
// import right from "../Assets/images/ic_arrow_right.svg";
// import sms from "../Assets/images/sms.svg";
// import call from "../Assets/images/call.svg";
// import web from "../Assets/images/web 1.svg";
// import Calendar from "react-calendar";
// import holiday from '../Assets/images/holiday.svg'
// import "react-calendar/dist/Calendar.css";

// function InfoCard({ selectedBank }) {
//   const [show, setShow] = useState(false);
//   const [modalContent, setModalContent] = useState(null);
//   const [modalTitle, setModalTitle] = useState("");
//   // const [value, onChange] = useState(new Date());
//   const [selectedCard, setSelectedCard] = useState(null);
// const [showModal, setShowModal] = useState(false);

//   const [value, setValue] = useState(new Date());

//   // const [holidays, setHolidays] = useState([]);
//   // const [loading, setLoading] = useState(true);

//   // useEffect(() => {
//   //   const fetchHolidays = async () => {
//   //     try {
//   //       const res = await fetch(
//   //         `https://calendarific.com/api/v2/holidays?api_key=zi74EEvbIJw9oV96N7fjbD9TPAdYtSq5&country=IN&year=2025`
//   //       );
//   //       const data = await res.json();

//   //       if (data && data.response && data.response.holidays) {
//   //         setHolidays(data.response.holidays);
//   //       }
//   //     } catch (err) {
//   //       console.error("Error fetching holidays:", err);
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   //   fetchHolidays();
//   // }, []);

//   // const handleCardClick = (title, content) => {
//   //   setModalTitle(title);
//   //   setModalContent(content);
//   //   setShow(true);
//   // };
//    const [holidays, setHolidays] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // useEffect(() => {
//   //   const fetchHolidays = async () => {
//   //     try {
//   //       const res = await fetch(
//   //         `https://calendarific.com/api/v2/holidays?api_key=zi74EEvbIJw9oV96N7fjbD9TPAdYtSq5&country=IN&year=2025`
//   //       );
//   //       const data = await res.json();

//   //       if (data && data.response && data.response.holidays) {
//   //         setHolidays(data.response.holidays);
//   //       }
//   //     } catch (err) {
//   //       console.error("Error fetching holidays:", err);
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   //   fetchHolidays();
//   // }, []);
//   useEffect(() => {
//   const fetchHolidays = async () => {
//      setLoading(true);
//     try {
//       const year = value.getFullYear();
//        const res = await fetch(
//          `https://calendarific.com/api/v2/holidays?api_key=ebsPEohnzdLFaqexbdIt6eugwAD9yNM3&country=IN&year=${year}`
//        );
//        const data = await res.json();

//        if (data && data.response && data.response.holidays) {
//          setHolidays(data.response.holidays);
//        }
//      } catch (err) {
//        console.error("Error fetching holidays:", err);
//      } finally {
//        setLoading(false);
//      }
//    };

//    fetchHolidays();
//  }, [value.getFullYear()]);

//   // Function to filter holidays by selected month and year
//   // const getHolidaysForSelectedMonth = () => {
//   //   const selectedMonth = value.getMonth(); // 0-11
//   //   const selectedYear = value.getFullYear();

//   //   return holidays.filter(holiday => {
//   //     const holidayDate = new Date(holiday.date.iso);
//   //     return (
//   //       holidayDate.getMonth() === selectedMonth &&
//   //       holidayDate.getFullYear() === selectedYear
//   //     );
//   //   });

//   // };
// // const getHolidaysForSelectedMonth = () => {
// //   const selectedMonth = value.getMonth(); // 0-11
// //   const selectedYear = value.getFullYear();

// //   const filtered = holidays.filter((holiday) => {
// //     const holidayDate = new Date(holiday.date.iso);
// //     return (
// //       holidayDate.getMonth() === selectedMonth &&
// //       holidayDate.getFullYear() === selectedYear
// //     );
// //   });

// //   console.log(
// //     `📌 Holidays for ${getMonthName(value)} ${selectedYear}:`,
// //     filtered.map((h) => h.name)
// //   );

// //   console.log("filtered",filtered)
// //   return filtered;
// // };
// const getHolidaysForSelectedMonth = () => {
//   const selectedMonth = value.getMonth();
//   const selectedYear = value.getFullYear();
//   return holidays.filter((holiday) => {
//     const holidayDate = new Date(holiday.date.iso);
//     return (
//       holidayDate.getMonth() === selectedMonth &&
//       holidayDate.getFullYear() === selectedYear
//     );
//   });
// };

//   // Function to get month name
//   const getMonthName = (date) => {
//     return date.toLocaleDateString('en-US', { month: 'long' });
//   };

//   const handleCardClick = (title, content) => {
//     setModalTitle(title);
//     setModalContent(content);
//     setShow(true);
//   };
// const handleCardClick2 = (title) => {
//     setSelectedCard(title);
//     setShowModal(true);
//   };
//   // Handle calendar date/view change
//   const handleCalendarChange = (newValue) => {
//       // console.log("📅 Date selected:", newValue);
//     // onChange(newValue);
//     setValue(newValue);
//   };

//   // Handle month navigation
//   // const onActiveStartDateChange = ({ activeStartDate }) => {
//   //   if (activeStartDate) {
//   //     console.log(
//   //     "➡️ Month changed:",
//   //     activeStartDate.toLocaleDateString("en-US", { month: "long", year: "numeric" })
//   //   );
//   //     onChange(activeStartDate);
//   //   }
//   // };
//   const onActiveStartDateChange = ({ activeStartDate }) => {
//   if (activeStartDate) {
//     // console.log(
//     //   "➡️ Month changed:",
//     //   activeStartDate.toLocaleDateString("en-US", { month: "long", year: "numeric" })
//     // );
//     // onChange(activeStartDate);
//     setValue(activeStartDate);

//     // 👇 force log immediately
//     const month = activeStartDate.getMonth();
//     const year = activeStartDate.getFullYear();
//     const filtered = holidays.filter((holiday) => {
//       const holidayDate = new Date(holiday.date.iso);
//       return (
//         holidayDate.getMonth() === month &&
//         holidayDate.getFullYear() === year
//       );
//     });
//     // console.log(
//     //   `📌 Holidays for ${activeStartDate.toLocaleDateString("en-US", { month: "long" })} ${year}:`,
//     //   filtered.map((h) => h.name)
//     // );

//   }
// };

//   return (
//     <>
//       <Row className="d-flex justify-content-center">
//         {/* Bank Balance */}
//         <Col lg={3} md={5} sm={12}>
//           <Card
//             className="card card2"
//             onClick={() =>
//               handleCardClick(
//                  selectedBank ? selectedBank.label : "Select Bank First",
//                 <div>
//                   <div className="d-flex align-items-center justify-content-center relative">
//                     <img src={bankImg} style={{ height: "200px" }} alt="" />
//                   </div>
//                   <div className="container mt-5 d-flex flex-column gap-4 p-0">
//                     <div>
//                       <div className=" main d-flex align-items-center justify-content-between">
//                         <div className="d-flex align-items-center gap-3">
//                           <img
//                           className="icon-img"
//                             // style={{ height: "40px" }}
//                             src={earning}
//                             alt=""
//                           />
//                           <div className="">
//                             <h5 className="mb-0 h5-text">Bank Balance</h5>
//                             <h6 className="mt-1 mb-0 h6-text" style={{ color: "#565050" }}>
//                               {" "}
//                               {selectedBank
//                                 ? selectedBank.balance
//                                 : "Select a bank first"}
//                             </h6>
//                           </div>
//                         </div>
//                         <img src={phone} className="phone-icon" alt="" />
//                       </div>
//                     </div>
//                     <div className=" main d-flex align-items-center justify-content-between">
//                       <div className=" d-flex align-items-center gap-3">
//                         <img
//                           src={statement}
//                            className="icon-img"
//                           // style={{ height: "40px" }}
//                           alt=""
//                         />
//                         <div>
//                           <h5 className="mb-0 h5-text">Mini Statement</h5>
//                           <h6 className="mt-1 mb-0 h6-text" style={{ color: "#565050" }}>
//                             {selectedBank
//                               ? selectedBank.statement
//                               : "Select a bank first"}
//                           </h6>
//                         </div>
//                       </div>
//                       <img src={phone} style={{ height: "25px" }} alt="" />
//                     </div>
//                     <div className=" main d-flex align-items-center justify-content-between mb-4">
//                       <div className="d-flex align-items-center gap-3">
//                         <img
//                           src={customerservice}
//                            className="icon-img"
//                           // style={{ height: "30px" }}
//                           alt=""
//                         />
//                         <div>
//                           <h5 className="mb-0 h5-text">Customer Care</h5>
//                           <h6 className="mt-1 mb-0 h6-text" style={{ color: "#565050" }}>
//                             {" "}
//                             {selectedBank
//                               ? selectedBank.customercare
//                               : "Select a bank first"}
//                           </h6>
//                         </div>
//                       </div>
//                       <img src={phone} style={{ height: "25px" }} alt="" />
//                     </div>
//                   </div>
//                 </div>
//               )
//             }
//           >
//             <div className="img-div">
//               <img
//                 className="card-img1"
//                 style={{ height: "40px" }}
//                 src={balance}
//                 alt=""
//               />
//             </div>
//             <div className="card-body d-flex align-items-center justify-content-center">
//               <Card.Title>Bank Balance</Card.Title>
//             </div>
//           </Card>
//         </Col>

//         {/* Net Banking */}
//         <Col lg={3} md={5} sm={12}>
//           <Card
//             className="card card2"
//             onClick={() =>
//               handleCardClick(
//                 "Net Banking",
//                 <div>
//                   <div className="d-flex flex-column justify-content-center text-center">
//                     <img src={netbanking} alt="" style={{ height: "230px" }} />
//                     <p>
//                       Log in to Net Banking to manage your money anytime,
//                       anywhere .
//                     </p>
//                     {/* <Link to="https://www.onlinesbi.sbi/" target="_blank" rel="noreferrer" className="link" style={{color:"red"}}>
//                    Proceed to Net Banking
//                   </Link> */}
//                     {selectedBank ? (
//                       <a
//                         href={selectedBank.netbanking}
//                         target="_blank"
//                         rel="noreferrer"
//                         className="link"
//                         style={{ color: "red" }}
//                       >
//                         Proceed to {selectedBank.label} Net Banking
//                       </a>
//                     ) : (
//                       <p>Please select a bank first</p>
//                     )}
//                   </div>
//                 </div>
//               )
//             }
//           >
//             <div className="img-div">
//               <img
//                 className="card-img1"
//                 style={{ height: "40px" }}
//                 src={bank}
//                 alt=""
//               />
//             </div>
//             <div className="card-body d-flex align-items-center justify-content-center">
//               <Card.Title>Net Banking</Card.Title>
//             </div>
//           </Card>
//         </Col>

//         {/* EPF Balance */}
//         <Col lg={3} md={5} sm={12}>
//           <Card
//             className="card card2"
//             onClick={() =>
//               handleCardClick(
//                 "Balance Check",
//                 <div>
//                   <div className="">
//                     <h6>PRE-REQUEST FOR AVILABLE MISSED CALL FACILITY</h6>
//                     <div className="d-flex flex-column mt-4 gap-3">
//                       <p className="mb-0 text-start">
//                         1. Mobile number must activated with UAN at unified
//                         portal.
//                       </p>
//                       <p className="mb-0 text-start">
//                         2. Any one of following KYC must be available against
//                         the UAN.
//                       </p>
//                       <div>
//                         <p className="mb-0 text-start">- Bank A/c Number.</p>
//                         <p className="mb-0 text-start">- Adhaar</p>
//                         <p className="mb-0 text-start">- PAN</p>
//                       </div>
//                     </div>
//                     <div className="container mt-4 d-flex flex-column gap-4 p-0">
//                       <div className="main2">
//                         <div className="d-flex align-items-center justify-content-between">
//                           <div
//                             className="d-flex align-items-center gap-3"
//                             onClick={() => {
//                               window.location.href = `sms:7738299899?body=EPFOHO%20UAN%20ENG`;
//                             }}
//                             style={{ cursor: "pointer" }}
//                           >
//                             <div className="sms">
//                               <img
//                                 style={{ height: "22px" }}
//                                 src={sms}
//                                 alt=""
//                               />
//                             </div>
//                             <div className="">
//                               <h6 className="mb-0">Balance Detail (SMS)</h6>
//                             </div>
//                           </div>
//                           <img src={right} style={{ height: "20px" }} alt="" />
//                         </div>
//                       </div>
//                       <div
//                         className="d-flex align-items-center justify-content-between main2"
//                         onClick={() => {
//                           if (!selectedBank || !selectedBank.balance) {
//                             alert("Please select a bank first");
//                             return;
//                           }
//                           window.location.href = `tel:${selectedBank.balance}`;
//                         }}
//                         style={{ cursor: "pointer" }}
//                       >
//                         <div className="d-flex align-items-center gap-3">
//                           <div className="call">
//                             <img src={call} style={{ height: "22px" }} alt="" />
//                           </div>
//                           <div>
//                             <h6 className="mb-0">Balance Detail (CALL)</h6>
//                           </div>
//                         </div>
//                         <img src={right} style={{ height: "20px" }} alt="" />
//                       </div>
//                       <a
//                         href="https://passbook.epfindia.gov.in/MemberPassBook/login"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="netbanking-text"
//                       >
//                         <div className="d-flex align-items-center justify-content-between main2">
//                           <div className="d-flex align-items-center gap-3">
//                             <div className="laptop">
//                               <img
//                                 src={web}
//                                 style={{ height: "22px" }}
//                                 alt=""
//                               />
//                             </div>

//                             <div>
//                               <h6 className="mb-0">Balance Detail (ONLINE)</h6>
//                             </div>
//                           </div>
//                           <img src={right} style={{ height: "20px" }} alt="" />
//                         </div>
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               )
//             }
//           >
//             <div className="img-div">
//               <img
//                 className="card-img1"
//                 style={{ height: "40px" }}
//                 src={money}
//                 alt=""
//               />
//             </div>
//             <div className="card-body d-flex align-items-center justify-content-center">
//               <Card.Title>EPF Balance</Card.Title>
//             </div>
//           </Card>
//         </Col>

//         {/* Bank Holiday */}
//         {/* <Col lg={3} md={5} sm={12}>
//           <Card
//             className="card card2"
//             onClick={() =>
//               handleCardClick(
//                 "Bank Holiday",
//                 <div className="">
//                     <Calendar
//                     onChange={handleCalendarChange}
//                     value={value}
//                     onActiveStartDateChange={onActiveStartDateChange}
//                   />

//                   <h2>{getMonthName(value)} Holidays</h2>

//                   {loading ? (
//                     <p>Loading holidays...</p>
//                   ) : (
//                     <div>
//                       {getHolidaysForSelectedMonth().length > 0 ? (
//                         <ul style={{ listStyle: 'none', padding: 0 }}>
//                           {getHolidaysForSelectedMonth().map((holiday, index) => (
//                             <li key={index} style={{
//                               display: 'flex',
//                               alignItems: 'center',
//                               marginBottom: '15px',
//                               padding: '10px',
//                               backgroundColor: '#f8f9fa',
//                               borderRadius: '8px'
//                             }}>
//                               <div style={{
//                                 backgroundColor: '#ff6b35',
//                                 color: 'white',
//                                 padding: '8px 12px',
//                                 borderRadius: '6px',
//                                 marginRight: '15px',
//                                 textAlign: 'center',
//                                 minWidth: '60px'
//                               }}>
//                                 <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
//                                   {new Date(holiday.date.iso).getDate()}
//                                 </div>
//                                 <div style={{ fontSize: '12px' }}>
//                                   {new Date(holiday.date.iso).toLocaleDateString('en-US', { month: 'short' })}
//                                 </div>
//                               </div>
//                               <div>
//                                 <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
//                                   {holiday.name}
//                                 </div>
//                                 {holiday.states && (
//                                   <div style={{ fontSize: '12px', color: '#666' }}>
//                                     State: {holiday.states}
//                                   </div>
//                                 )}
//                               </div>
//                             </li>
//                           ))}
//                         </ul>
//                       ) : (
//                         <p style={{ textAlign: 'center', color: '#666', fontStyle: 'italic' }}>
//                           No holidays found for {getMonthName(value)}
//                         </p>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               )
//             }
//           >
//             <div className="img-div">
//               <Calender className="card-img1" style={{ height: "35px" }} />
//             </div>
//             <div className="card-body d-flex align-items-center justify-content-center">
//               <Card.Title>Bank Holiday</Card.Title>
//             </div>
//           </Card>
//         </Col> */}
//         <Col lg={3} md={5} sm={12}>
//   <Card className="card card2" onClick={() => handleCardClick2("Bank Holiday")}>
//     <div className="img-div">
//       {/* <Calender className="card-img1" style={{ height: "35px" }} /> */}
//               <img
//                 className="card-img1"
//                 style={{ height: "40px" }}
//                 src={holiday}
//                 alt=""
//               />
//               {/* <Holiday style={{ height: "38px" ,fill:"white"}}stroke="white"  strokeWidth={3}/> */}
//     </div>
//     <div className="card-body d-flex align-items-center justify-content-center">
//       <Card.Title>Bank Holiday</Card.Title>
//     </div>
//   </Card>
// </Col>
//       </Row>

//       {/* One reusable modal */}
//       <Modal show={show} onHide={() => setShow(false)} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>{modalTitle}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>{modalContent}</Modal.Body>
//       </Modal>

//       <Modal show={showModal} onHide={() => setShowModal(false)} centered>
//   <Modal.Header closeButton>
//     <Modal.Title>{selectedCard}</Modal.Title>
//   </Modal.Header>
//   <Modal.Body>
//     {selectedCard === "Bank Holiday" && (
//       <>
//       <div className="d-flex justify-content-center">
//         <Calendar
//           onChange={handleCalendarChange}
//           value={value}
//           onActiveStartDateChange={onActiveStartDateChange}
//           // prev2Label={null}  // removes «
//           // next2Label={null}  // removes »
//         />
//         </div>

//         <h5 className="mt-5 mb-4" style={{color:"#00000087"}} >{getMonthName(value)} Holidays</h5>

//         {loading ? (
//           <p>Loading holidays...</p>
//         ) : getHolidaysForSelectedMonth().length > 0 ? (
//           <ul style={{ listStyle: "none", padding: 0 ,height:"350px",width:"auto",overflowY:"auto",scrollbarWidth: "none",msOverflowStyle: "none"}}>
//             {getHolidaysForSelectedMonth().map((holiday, index) => (
//               <li
//                 key={index}
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   marginBottom: "15px",
//                   padding: "10px",
//                   backgroundColor: "#f8f9fa",
//                   borderRadius: "8px",
//                    width:"auto",
//                 }}
//               >
//                 <div
//                   style={{
//                     backgroundColor: "#589ff3",
//                     color: "white",
//                     padding: "5px",
//                     borderRadius: "6px",
//                     marginRight: "15px",
//                     textAlign: "center",
//                     minWidth: "53px",
//                   }}
//                 >
//                   <div className="holiday" style={{ fontSize: "18px"}}>
//                     {new Date(holiday.date.iso).getDate()}
//                   </div>
//                   <div style={{ fontSize: "12px" }}>
//                     {new Date(holiday.date.iso).toLocaleDateString("en-US", {
//                       month: "short",
//                     })}
//                   </div>
//                 </div>
//                 <div>
//                   <div className="holiday" style={{ fontSize:"18px", marginBottom: "4px" ,color:"#0c2139", textAlign:"left"}}>
//                     {holiday.name}
//                   </div>
//                 </div>
//               </li>
//             ))}
//           </ul>
//         ) : (
//           <p
//             style={{
//               textAlign: "center",
//               color: "#666",
//               fontStyle: "italic",
//             }}
//           >
//             No holidays found for {getMonthName(value)}
//           </p>
//         )}
//       </>
//     )}
//   </Modal.Body>
// </Modal>

//     </>
//   );
// }

// export default InfoCard;

import { useEffect, useState } from "react";
import { Row, Col, Card, Modal } from "react-bootstrap";
import Select from "react-select";
import balance from "../Assets/images/smartphone.svg";
import bank from "../Assets/images/bank4.svg";
import money from "../Assets/images/money.svg";
import { ReactComponent as Calender } from "../Assets/images/calendar.svg";
import bankImg from "../Assets/images/bank-img1.png";
import statement from "../Assets/images/Frame 1.png";
import { options } from "./Array";
import holiday from "../Assets/images/holiday.svg";
import earning from "../Assets/images/earning.png";
import customerservice from "../Assets/images/customer-service.png";
import phone from "../Assets/images/phone.svg";
import netbanking from "../Assets/images/netbanking.svg";
import Calendar from "react-calendar";
import right from "../Assets/images/ic_arrow_right.svg";
import sms from "../Assets/images/sms.svg";
import call from "../Assets/images/call.svg";
import web from "../Assets/images/web 1.svg";

function InfoCard({ selectedBank, setSelectedBank }) {
  const [show, setShow] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(new Date());

  // open modal with type + title
  const handleCardClick = (type, title) => {
    setModalType(type);
    setModalTitle(title);
    setShow(true);
  };
  useEffect(() => {
    const fetchHolidays = async () => {
      setLoading(true);
      try {
        const year = value.getFullYear();
        const res = await fetch(
          `https://calendarific.com/api/v2/holidays?api_key=3yyNNPMVrEbbxyDKamR96o4gKFZJAY3d
 &country=IN&year=${year}`  // calendarific.com/login -->  get your free api key
        );
        const data = await res.json();

        if (data && data.response && data.response.holidays) {
          setHolidays(data.response.holidays);
        }
      } catch (err) {
        console.error("Error fetching holidays:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchHolidays();
  }, [value.getFullYear()]);

  useEffect(() => {
  if (modalType === "balance" && selectedBank) {
    setModalTitle(selectedBank.label);
  }
}, [selectedBank, modalType]);

  const getHolidaysForSelectedMonth = () => {
    const selectedMonth = value.getMonth();
    const selectedYear = value.getFullYear();
    return holidays.filter((holiday) => {
      const holidayDate = new Date(holiday.date.iso);
      return (
        holidayDate.getMonth() === selectedMonth &&
        holidayDate.getFullYear() === selectedYear
      );
    });
  };

  // Function to get month name
  const getMonthName = (date) => {
    return date.toLocaleDateString("en-US", { month: "long" });
  };

  // const handleCardClick2 = (title) => {
  //     setSelectedCard(title);
  //     setShowModal(true);
  //   };
  // Handle calendar date/view change
  const handleCalendarChange = (newValue) => {
    // console.log("📅 Date selected:", newValue);
    // onChange(newValue);
    setValue(newValue);
  };

  // Handle month navigation
  // const onActiveStartDateChange = ({ activeStartDate }) => {
  //   if (activeStartDate) {
  //     console.log(
  //     "➡️ Month changed:",
  //     activeStartDate.toLocaleDateString("en-US", { month: "long", year: "numeric" })
  //   );
  //     onChange(activeStartDate);
  //   }
  // };
  const onActiveStartDateChange = ({ activeStartDate }) => {
    if (activeStartDate) {
      // console.log(
      //   "➡️ Month changed:",
      //   activeStartDate.toLocaleDateString("en-US", { month: "long", year: "numeric" })
      // );
      // onChange(activeStartDate);
      setValue(activeStartDate);

      // 👇 force log immediately
      const month = activeStartDate.getMonth();
      const year = activeStartDate.getFullYear();
      const filtered = holidays.filter((holiday) => {
        const holidayDate = new Date(holiday.date.iso);
        return (
          holidayDate.getMonth() === month && holidayDate.getFullYear() === year
        );
      });
      // console.log(
      //   `📌 Holidays for ${activeStartDate.toLocaleDateString("en-US", { month: "long" })} ${year}:`,
      //   filtered.map((h) => h.name)
      // );
    }
  };

  return (
    <>
      <Row className="d-flex justify-content-center">
        {/* Bank Balance */}
        <Col lg={3} md={5} sm={12}>
          <Card
            className="card card2"
            onClick={() =>
            handleCardClick( "balance",selectedBank ? selectedBank.label : "Bank Balance" )}
          >
            <div className="img-div">
              <img
                className="card-img1"
                style={{ height: "40px" }}
                src={balance}
                alt="balance"
              />
            </div>
            <div className="card-body d-flex align-items-center justify-content-center">
              <Card.Title>Bank Balance</Card.Title>
            </div>
          </Card>
        </Col>

        {/* Net Banking */}
        <Col lg={3} md={5} sm={12}>
          <Card
            className="card card2"
            onClick={() => handleCardClick("netbanking", "Net Banking")}
          >
            <div className="img-div">
              <img
                className="card-img1"
                style={{ height: "40px" }}
                src={bank}
                alt="netbanking"
              />
            </div>
            <div className="card-body d-flex align-items-center justify-content-center">
              <Card.Title>Net Banking</Card.Title>
            </div>
          </Card>
        </Col>
        <Col lg={3} md={5} sm={12}>
          <Card
            className="card card2"
            onClick={() => handleCardClick("statement", "Bank Statement")}
          >
            <div className="img-div">
              <img
                className="card-img1"
                style={{ height: "40px" }}
                src={money}
                alt="statement"
              />
            </div>
            <div className="card-body d-flex align-items-center justify-content-center">
              <Card.Title>EPF Balance</Card.Title>
            </div>
          </Card>
        </Col>

        {/* Bank Holidays */}
        <Col lg={3} md={5} sm={12}>
          <Card
            className="card card2"
            onClick={() => handleCardClick("holidays", "Bank Holidays")}
          >
            <div className="img-div">
              <img
                className="card-img1"
                style={{ height: "40px" }}
                src={holiday}
                alt=""
              />
            </div>
            <div className="card-body d-flex align-items-center justify-content-center">
              <Card.Title>Bank Holidays</Card.Title>
            </div>
          </Card>
        </Col>

        {/* Bank Statement */}
      </Row>

      {/* 🔹 One reusable modal */}
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Shared Select */}

          {/* Modal content by type */}
          {modalType === "balance" && (
            <>
             {/* <Select
                  options={options}
                  placeholder="Select Your Bank"
                  isSearchable={true} // Enables search
                  isClearable={true}
                  value={selectedBank}
                  onChange={(option) => setSelectedBank(option)}
                  styles={{
                    control: (base) => ({
                      ...base,
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "8px",
                    }),
                    menu: (base) => ({
                      ...base,
                      maxHeight: "200px",
                      width: "100%",
                      overflowY: "auto",
                      borderRadius: "8px",
                    }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: "200px",
                      overflowY: "auto",
                    }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      "& svg": {
                        width: "30px", // Increase width
                        height: "30px", // Increase height
                      },
                    }),
                  }}
                /> */}
              <div className="d-flex align-items-center justify-content-center relative mt-4">
                <img src={bankImg} style={{ height: "200px" }} alt="" />
              </div>
               <Select
               className="mt-4"
                  options={options}
                  placeholder="Select Your Bank"
                  isSearchable={true} // Enables search
                  isClearable={true}
                  value={selectedBank}
                  onChange={(option) => setSelectedBank(option)}
                  styles={{
                    control: (base) => ({
                      ...base,
                      width: "100%",
                      minHeight: "50px",
                      borderRadius: "12px",
                      borderColor:"#80808057",
                      backgroundColor:"#f8f9fa",
                      padding:"6px 8px",
                      boxShadow: "none", // 🔴 remove default blue shadow
                      "&:hover": {
                        borderColor: "#80808057",
                      },
                    }),
                    menu: (base) => ({
                      ...base,
                      maxHeight: "200px",
                      width: "100%",
                      overflowY: "auto",
                      borderRadius: "10px",
                    }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: "200px",
                      overflowY: "auto",
                    }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      "& svg": {
                        width: "30px", // Increase width
                        height: "30px", // Increase height
                      },
                    }),
                  }}
                />
              <div className="mb-3">
                {/* <Select
                  options={options}
                  placeholder="Select Your Bank"
                  isSearchable
                  isClearable
                  value={selectedBank}
                  onChange={(option) => setSelectedBank(option)}
                /> */}
                
              </div>
              <div className="container mt-4 d-flex flex-column gap-4 p-0">
                {/* Bank Balance */}
                {/* <div className="main d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-3">
                    <img className="icon-img" src={earning} alt="" />
                    <div>
                      <h5 className="mb-0 h5-text">Bank Balance</h5>
                      <h6
                        className="mt-1 mb-0 h6-text"
                        style={{ color: "#565050" }}
                      >
                        {selectedBank
                          ? selectedBank.balance
                          : "Select a bank first"}
                      </h6>
                    </div>
                  </div>
                  <img src={phone} className="phone-icon" alt="" />
                </div> */}

                {/* Mini Statement */}
                {/* <div className="main d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-3">
                    <img className="icon-img" src={statement} alt="" />
                    <div>
                      <h5 className="mb-0 h5-text">Mini Statement</h5>
                      <h6
                        className="mt-1 mb-0 h6-text"
                        style={{ color: "#565050" }}
                      >
                        {selectedBank
                          ? selectedBank.statement
                          : "Select a bank first"}
                      </h6>
                    </div>
                  </div>
                  <img src={phone} style={{ height: "25px" }} alt="" />
                </div> */}

                {/* Customer Care */}
                {/* <div className="main d-flex align-items-center justify-content-between mb-4">
                  <div className="d-flex align-items-center gap-3">
                    <img className="icon-img" src={customerservice} alt="" />
                    <div>
                      <h5 className="mb-0 h5-text">Customer Care</h5>
                      <h6
                        className="mt-1 mb-0 h6-text"
                        style={{ color: "#565050" }}
                      >
                        {selectedBank
                          ? selectedBank.customercare
                          : "Select a bank first"}
                      </h6>
                    </div>
                  </div>
                  <img src={phone} style={{ height: "25px" }} alt="" />
                </div> */}
                <div className="new">
                <div className=" d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-3 ">
                    <img className="icon-img" src={earning} alt="" />
                    <div>
                      <h5 className="mb-0 h5-text">Bank Balance</h5>
                      <h6
                        className="mt-1 mb-0 h6-text"
                        style={{ color: "#565050" }}
                      >
                        {selectedBank
                          ? selectedBank.balance
                          : "Select a bank first"}
                      </h6>
                    </div>
                  </div>
                  <img src={phone} className="phone-icon" alt="" />
                </div>
                  <hr  style={{margin:"14px 5px", color:"#808080c2"}}/>
                <div className=" d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-3 ">
                    <img className="icon-img" src={statement} alt="" />
                    <div>
                      <h5 className="mb-0 h5-text">Mini Statement</h5>
                      <h6
                        className="mt-1 mb-0 h6-text"
                        style={{ color: "#565050" }}
                      >
                        {selectedBank
                          ? selectedBank.statement
                          : "Select a bank first"}
                      </h6>
                    </div>
                  </div>
                  <img src={phone} style={{ height: "25px" }} alt="" />
                </div>
                <hr  style={{margin:"14px 5px", color:"#808080c2"}}/>
                 <div className=" d-flex align-items-center justify-content-between ">
                  <div className="d-flex align-items-center gap-3 ">
                    <img className="icon-img" src={customerservice} alt="" />
                    <div>
                      <h5 className="mb-0 h5-text">Customer Care</h5>
                      <h6
                        className="mt-1 mb-0 h6-text"
                        style={{ color: "#565050" }}
                      >
                        {selectedBank
                          ? selectedBank.customercare
                          : "Select a bank first"}
                      </h6>
                    </div>
                  </div>
                  <img src={phone} style={{ height: "25px" }} alt="" />
                </div>          
</div>
              </div>
            </>
          )}

          {modalType === "netbanking" && (
            <div>
              <div className="d-flex flex-column justify-content-center text-center">
                <img src={netbanking} alt="" style={{ height: "230px" }} />
                <p>
                  Log in to Net Banking to manage your money anytime, anywhere.
                </p>

                {selectedBank ? (
                  <a
                    href={selectedBank.netbanking}
                    target="_blank"
                    rel="noreferrer"
                    className="link"
                    style={{ color: "red" }}
                  >
                    Proceed to {selectedBank.label} Net Banking
                  </a>
                ) : (
                  <p>Please select a bank first</p>
                )}
              </div>
            </div>
          )}

          {modalType === "holidays" && (
            <div>
              <>
                <div className="d-flex justify-content-center">
                  <Calendar
                    onChange={handleCalendarChange}
                    value={value}
                    onActiveStartDateChange={onActiveStartDateChange}
                    // prev2Label={null}
                    // next2Label={null}
                  />
                </div>

                <h5 className="mt-5 mb-4" style={{ color: "#00000087" }}>
                  {getMonthName(value)} Holidays
                </h5>

                {loading ? (
                  <p>Loading holidays...</p>
                ) : getHolidaysForSelectedMonth().length > 0 ? (
                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      height: "350px",
                      width: "auto",
                      overflowY: "auto",
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                    }}
                  >
                    {getHolidaysForSelectedMonth().map((holiday, index) => (
                      <li
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "15px",
                          padding: "10px",
                          backgroundColor: "#f8f9fa",
                          borderRadius: "8px",
                          width: "auto",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#589ff3",
                            color: "white",
                            padding: "5px",
                            borderRadius: "6px",
                            marginRight: "15px",
                            textAlign: "center",
                            minWidth: "53px",
                          }}
                        >
                          <div className="holiday" style={{ fontSize: "18px" }}>
                            {new Date(holiday.date.iso).getDate()}
                          </div>
                          <div style={{ fontSize: "12px" }}>
                            {new Date(holiday.date.iso).toLocaleDateString(
                              "en-US",
                              {
                                month: "short",
                              }
                            )}
                          </div>
                        </div>

                        <div>
                          <div
                            className="holiday"
                            style={{
                              fontSize: "18px",
                              marginBottom: "4px",
                              color: "#0c2139",
                              textAlign: "left",
                            }}
                          >
                            {holiday.name}
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p
                    style={{
                      textAlign: "center",
                      color: "#666",
                      fontStyle: "italic",
                    }}
                  >
                    No holidays found for {getMonthName(value)}
                  </p>
                )}
              </>
            </div>
          )}

          {modalType === "statement" && (
            <div>
              <div>
                <h6>PRE-REQUEST FOR AVAILABLE MISSED CALL FACILITY</h6>

                <div className="d-flex flex-column mt-4 gap-3">
                  <p className="mb-0 text-start">
                    1. Mobile number must be activated with UAN at unified
                    portal.
                  </p>
                  <p className="mb-0 text-start">
                    2. Any one of the following KYC must be available against
                    the UAN.
                  </p>
                  <div>
                    <p className="mb-0 text-start">- Bank A/c Number</p>
                    <p className="mb-0 text-start">- Aadhaar</p>
                    <p className="mb-0 text-start">- PAN</p>
                  </div>
                </div>

                <div className="container mt-4 d-flex flex-column gap-4 p-0">
                  {/* SMS Option */}
                  <div className="main2">
                    <div
                      className="d-flex align-items-center justify-content-between"
                      onClick={() => {
                        window.location.href = `sms:7738299899?body=EPFOHO%20UAN%20ENG`;
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <div className="sms">
                          <img style={{ height: "22px" }} src={sms} alt="" />
                        </div>
                        <div>
                          <h6 className="mb-0">Balance Detail (SMS)</h6>
                        </div>
                      </div>
                      <img src={right} style={{ height: "20px" }} alt="" />
                    </div>
                  </div>

                  {/* CALL Option */}
                  <div
                    className="d-flex align-items-center justify-content-between main2"
                    onClick={() => {
                      if (!selectedBank || !selectedBank.balance) {
                        alert("Please select a bank first");
                        return;
                      }
                      window.location.href = `tel:${selectedBank.balance}`;
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <div className="call">
                        <img src={call} style={{ height: "22px" }} alt="" />
                      </div>
                      <div>
                        <h6 className="mb-0">Balance Detail (CALL)</h6>
                      </div>
                    </div>
                    <img src={right} style={{ height: "20px" }} alt="" />
                  </div>

                  {/* ONLINE Option */}
                  <a
                    href="https://passbook.epfindia.gov.in/MemberPassBook/login"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="netbanking-text"
                  >
                    <div className="d-flex align-items-center justify-content-between main2">
                      <div className="d-flex align-items-center gap-3">
                        <div className="laptop">
                          <img src={web} style={{ height: "22px" }} alt="" />
                        </div>
                        <div>
                          <h6 className="mb-0">Balance Detail (ONLINE)</h6>
                        </div>
                      </div>
                      <img src={right} style={{ height: "20px" }} alt="" />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default InfoCard;
